import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import ChevronDown20 from '@carbon/icons-react/es/chevron--down/20';
import Close16 from '@carbon/icons-react/es/close/16';
import Close20 from '@carbon/icons-react/es/close/20';
import { List, Space } from 'antd';
import classNames from 'classnames';
import { forwardRef } from 'react';
import ReactSelect, { defaultTheme, components as RsComponents } from 'react-select';
import ReactCreatableSelect from 'react-select/creatable';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { HeightStyle } from 'components/atoms/input/input';
import { Avatar } from '../avatar';
import { Tag as TagAtom } from '../tag';
import { AvatarOption, StyledClearIndicator, StyledDropdownIndicator, StyledMultiValueLabel, StyledMultiValueRemove, StyledSingleValue, StyledTagOption } from './custom-components';
import { UserTag } from './select';
const DropdownIndicator = (props)=>{
    return /*#__PURE__*/ _jsx(StyledDropdownIndicator, {
        ...props,
        children: /*#__PURE__*/ _jsx(ChevronDown20, {})
    });
};
const StyledControl = styled(RsComponents.Control).attrs({
    theme: {
        ...defaultTheme
    }
})`
  outline: 2px solid !important;
  outline-color: transparent !important;
  outline-offset: -2px;
  border: 0;
  border-bottom: 1px solid var(--gray-50);
  border-radius: 0;
  background-color: var(--coolest-gray-10);
  min-height: ${HeightStyle};
  ${ifProp('isFocused', css`
      box-shadow: none;
      border-bottom-color: transparent !important;
      outline-color: var(--primary-color) !important;
      outline-offset: -2px;
    `)};
  &:hover {
    background-color: var(--hover-color);
  }
`;
const Control = (props)=>/*#__PURE__*/ _jsx(StyledControl, {
        ...props
    });
const ClearIndicator = (props)=>/*#__PURE__*/ _jsx(StyledClearIndicator, {
        ...props,
        children: /*#__PURE__*/ _jsx(Close20, {})
    });
const ListItem = styled(List.Item)`
  padding: 0;
`;
const ListItemMeta = styled(List.Item.Meta)`
  align-items: center;

  & .ant-list-item-meta-title {
    margin-bottom: 0;
    color: var(--gray-100);
  }

  & .ant-list-item-meta-description {
    font-size: var(--font-size-sm);
    color: var(--gray-80);
    font-weight: normal;
  }
`;
const Option = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(StyledTagOption, {
        ...props,
        children: /*#__PURE__*/ _jsx(ListItem, {
            children: /*#__PURE__*/ _jsx(ListItemMeta, {
                avatar: /*#__PURE__*/ _jsx(Avatar, {
                    name: data.__isNew__ ? data.value : data.label,
                    src: data.imageUrl
                }),
                title: data.label,
                description: data.description
            })
        })
    });
};
export const StyledMultiValue = styled(RsComponents.MultiValue).attrs({
    theme: {
        ...defaultTheme
    }
})`
  --tag-border-color: var(--tag-surface-color);

  border-radius: var(--border-radius-default);
  margin: var(--spacing-01) 0;
  padding: 0;
  border: 2px solid var(--tag-border-color);
  background: var(--tag-surface-color);
  color: var(--tag-color);
  font-size: var(--font-size-sm);
  line-height: var(--spacing-05);
  display: inline-flex;
  align-items: center;

  &:focus {
    --tag-border-color: var(--blue-60);
  }

  &.disabled,
  &[disabled] {
    --tag-surface-color: var(--gray-10);
    --tag-color: var(--gray-30);
  }

  ${({ color })=>css`
    --tag-surface-color: var(--ozone-${color}-surface);
    --tag-color: var(--ozone-${color});
  `};

  cursor: ${ifProp('onClick', 'pointer', 'initial')};
`;
const SingleValue = ({ data, ...props })=>{
    return /*#__PURE__*/ _jsx(StyledSingleValue, {
        ...props,
        children: /*#__PURE__*/ _jsx(UserTag, {
            color: data.color,
            imageUrl: data.imageUrl,
            label: data.label,
            userStatus: data === null || data === void 0 ? void 0 : data.userStatus
        })
    });
};
const MultiValue = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(StyledMultiValue, {
        color: (data === null || data === void 0 ? void 0 : data.color) || 'gray',
        ...props
    });
};
export const MultiValueLabel = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(StyledMultiValueLabel, {
        ...props,
        children: /*#__PURE__*/ _jsxs(Space, {
            size: "small",
            children: [
                /*#__PURE__*/ _jsx(Avatar, {
                    size: "small",
                    src: data.imageUrl,
                    name: data.label
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: data.label
                })
            ]
        })
    });
};
export const MultiValueRemove = ({ data, ...props })=>/*#__PURE__*/ _jsx(StyledMultiValueRemove, {
        ...props,
        children: /*#__PURE__*/ _jsx(Close16, {})
    });
const TagOption = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(StyledTagOption, {
        ...props,
        children: /*#__PURE__*/ _jsx(TagAtom, {
            color: data.color,
            children: data.label
        })
    });
};
const TagSingleValue = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(StyledSingleValue, {
        ...props,
        children: /*#__PURE__*/ _jsx(TagAtom, {
            color: data.color,
            children: data.label
        })
    });
};
export const CreatableSelect = ({ className, components = {}, ...props })=>{
    const { type } = props;
    let customComponents = {
        DropdownIndicator,
        ClearIndicator,
        Control,
        MultiValueRemove
    };
    if (type === 'user') {
        customComponents = {
            ...customComponents,
            Option,
            SingleValue,
            MultiValue,
            MultiValueLabel
        };
    } else if (type === 'tag') {
        customComponents = {
            ...customComponents,
            Option: TagOption,
            SingleValue: TagSingleValue,
            MultiValue
        };
    }
    return /*#__PURE__*/ _jsx(ReactCreatableSelect, {
        className: classNames('ozone-select-container', className),
        classNamePrefix: "ozone-select",
        theme: (theme)=>({
                ...theme,
                borderRadius: 0,
                colors: {
                    ...theme.colors || {},
                    primary: 'var(--primary-color)'
                }
            }),
        components: {
            ...customComponents,
            ...components
        },
        ...props
    });
};
export const Select = /*#__PURE__*/ forwardRef(({ className, components = {}, ...props }, ref)=>{
    const { type = 'basic' } = props;
    let customComponents = {
        DropdownIndicator,
        ClearIndicator,
        Control,
        MultiValueRemove
    };
    if (type === 'user') {
        customComponents = {
            ...customComponents,
            Option: AvatarOption,
            SingleValue,
            MultiValue,
            MultiValueLabel
        };
    } else if (type === 'tag') {
        customComponents = {
            ...customComponents,
            Option: TagOption,
            SingleValue: TagSingleValue,
            MultiValue
        };
    }
    /* TODO:: Remove this duplicate and make it into single. Note: I am stupidly sleepy while writing this component. So just POC implementation. */ return /*#__PURE__*/ _jsx(ReactSelect, {
        ref: ref,
        className: classNames('ozone-select-container', className),
        classNamePrefix: "ozone-select",
        theme: (theme)=>({
                ...theme,
                borderRadius: 0,
                colors: {
                    ...theme.colors || {},
                    primary: 'var(--primary-color)'
                }
            }),
        components: {
            ...customComponents,
            ...components
        },
        ...props
    });
});
Select.displayName = 'Select';
